import { combineReducers } from "redux";
import loadingReducer from "./loadingReducer";
import authReducer from "./authReducer";
import { LOGOUT } from "../types";
import sidebarReducer from "./sidebarReducer";
import modalReducer from "./modalReducer";
import nftsReducer from "./nftReducer";

const appReducer = combineReducers({
    auth: authReducer,
    loading: loadingReducer,
    sidebar: sidebarReducer,
    modal: modalReducer,
    nfts: nftsReducer,
});

const rootReducer = (state, action) => {
    if (action.type === LOGOUT) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
